import * as React from 'react';
import { ModuleProps } from 'src/utils/module-util';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { TabbedContentComponent } from './code-split/tabbed-content-component';

const TabbedContent: React.FC<ComponentLayoutType<any>> = (props) => {
  return (
    <>
      <ComponentLayout {...props}>
        <TabbedContentComponent />
      </ComponentLayout>
    </>
  );
};

export default TabbedContent;

const TabbedContentModule = (props: ModuleProps) => {
  const componentLayoutType: ComponentLayoutType<any> = {
    moduleName: 'tabbedContentModule',
    data: {
      ...props,
    },
  };

  return <TabbedContent {...componentLayoutType} />;
};

export { TabbedContentModule };
